import { Outlet } from "react-router-dom";

import { NavigationSidebarProvider } from "@/shared/state/appSidebar";
import { CollaborationBarProvider } from "@/shared/state/collaborationBar";

import styles from "./AppLayout.module.css";
import { AppNavigation } from "./AppNavigation";
import { CollaborationBar } from "./CollaborationBar";

/**
 * Top-level layout component for the app.
 */
export function AppLayout() {
  return (
    <NavigationSidebarProvider>
      <CollaborationBarProvider>
        <div className={styles.appLayout}>
          <AppNavigation />
          <Outlet />
          <CollaborationBar />
        </div>
      </CollaborationBarProvider>
    </NavigationSidebarProvider>
  );
}
